<template>
  <b-container fluid>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-row>
      <b-col>
        <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
          <label>Fecha inicio:<validacion/></label>
          <b-input-group size="sm" class="mb-2">
            <b-form-datepicker placeholder="Fecha inicio"
                               :max="new Date()"
                               @input="fechaMaxima($event)"
            ></b-form-datepicker>
          </b-input-group>
          <b-form-invalid-feedback :state="filtro.fechaInicio != null">
            Este campo es obligatorio
          </b-form-invalid-feedback>
        </validation-provider>
      </b-col>
      <b-col>
        <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext" v-if="filtro.fechaInicio !== null">
          <label>Fecha fin:<validacion/></label>
          <b-input-group size="sm" class="mb-2">
            <b-form-datepicker placeholder="Fecha fin"
                               v-model="filtro.fechaFin"
                               :max="filtro.fechaInicio.addDays(diasMaximoMes) > new Date() ? new Date(): filtro.fechaInicio.addDays(diasMaximoMes)"
                               :min="filtro.fechaInicio"
                               @input="listarCashBack"
            ></b-form-datepicker>
          </b-input-group>
          <b-form-invalid-feedback :state="filtro.fechaFin != null">
            Este campo es obligatorio
          </b-form-invalid-feedback>
        </validation-provider>
      </b-col>
    </b-row>
    <TablaEsteroides
        :items.sync="listMovimientos"
        :fields.sync="movimientoService.fieldsCashbackPorEstatus"
        :clinicas="listClinicas"
        @paginaActualHijo="paginaActualPadre = $event"
        @buscarInput="buscarInput"
        @ordenacionCambiada="manejarOrdenacionCambiada"
        @filtrarByClinica="filtrarPorClinica"
        >

      <template v-slot:cell(monto)="row">
        {{ row.item.aFavor ? row.item.monto : row.item.monto * -1 | moneda }}
      </template>

      <template v-slot:cell(diasSolucion)="row">
        <b-badge :variant="obtenerDiasParaResolver(row) > 0 ? 'info':'warning'">{{
            obtenerDiasParaResolver(row)
          }}
        </b-badge>
      </template>
      <template v-slot:cell(saldoTotal)="{item}">
        {{ item.saldoTotal | moneda }}
      </template>
      <template v-slot:cell(detalle)="row">
        <b-button
            v-b-modal="'detalle-'+row.item.idMovimiento"
            size="sm"
            variant="info"
        >
          <font-awesome-icon
              icon="eye"
          />
        </b-button>
        <b-modal
            ok-title="Aceptar"
                  cancel-title="Cerrar"
                  :id="'detalle-'+row.item.idMovimiento" title="Detalle del movimiento">
          <p class="my-4">
            <DetalleMovimiento :fields="movimientoService.fieldsMovimientoDetalle" :movimiento="row.item"/>
          </p>
        </b-modal>
      </template>
      <template v-slot:cell(aceptarMovimiento)="row" v-if="$localStorageService.can('CB_ch_estatus_aceptado')">
        <b-button
            size="sm"
            :disabled="itemEnEstatusFinal(row.item)"
            :variant="itemEnEstatusFinal(row.item) ? 'secondary': 'success'"
            v-on:click="cambiarEstatusAceptado(row)"
        >
          <font-awesome-icon
              icon="check"
          />
        </b-button>
      </template>
      <template v-slot:cell(pdf)="row">

        <MostrarComprobanteMovimiento v-if="row.item.fechaSolucion !== null" :id-movimiento="row.item.idMovimiento"/>
        <div v-else class="text-info">No se ha completado el proceso</div>
      </template>
      <template v-slot:cell(rechazarMovimiento)="row" v-if="$localStorageService.can('CB_ch_estatus_rechazado')">
        <b-button
            size="sm"
            :disabled="itemEnEstatusFinal(row.item)"
            :variant="itemEnEstatusFinal(row.item) ? 'secondary': 'danger'"
            v-on:click="cambiarEstatusRechazado(row)"
        >
          <font-awesome-icon
              icon="times"
          />
        </b-button>
      </template>
    </TablaEsteroides>
  </b-container>
</template>

<script>
import TablaEsteroides from "@/components/tablaConEsteroides/TablaEsteroides";
import DetalleMovimiento from "@/views/movimientos/movimiento/DetalleMovimiento";
import {MovimientoService} from "../../../apiServices/movimiento/MovimientoService";
import MostrarComprobanteMovimiento from "../movimiento/MostrarComprobanteMovimiento";

export default {
  name: "ListaCashbackPorEstatus",
  components: {MostrarComprobanteMovimiento, DetalleMovimiento, TablaEsteroides},
  props: {
    estatus: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      movimientoService: new MovimientoService(),
      diasMaximoMes: null,
      filtro: {
        fechaInicio: null,
        fechaFin: null
      },
      paginaActualPadre: 1,
      textInput: '',
      sortBy : 'fechaAlta',
      sortDirection: 'ASC',
      listMovimientos: [],
      listClinicas: [],
      idsClinicas: [],
    }
  },
  watch: {
    paginaActualPadre() {
      this.listarCashBack();
    }
  },
  methods: {
    buscarInput(valor) {
      this.textInput = valor;  // Actualizamos textInput con el valor recibido
      this.listarCashBack();
    },
    manejarOrdenacionCambiada(evento) {
      // Recibir la información de ordenación del componente hijo
      const { sortBy, sortDesc } = evento;
      this.sortBy = sortBy;
      this.sortDirection = sortDesc ? 'DESC' : 'ASC';
      this.listarCashBack();
    },
    filtrarPorClinica(evento) {
      this.idsClinicas = evento.idsClinica;
      this.listarCashBack();
    },
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;
    },
    async listarCashBack() {
      this.listMovimientos = await this.movimientoService.listarCashBackFecha({
        estatusMovimiento: this.estatus,
        fechaInicioZoned: this.filtro.fechaInicio,
        fechaFin: this.filtro.fechaFin,
        pagina: this.paginaActualPadre,
        buscar: this.textInput,
        sortBy: this.sortBy,
        sortDirection: this.sortDirection,
        idsClinica: this.idsClinicas,});

      let listaClinicas = await this.movimientoService.listarCashbackClinicas({estatusMovimiento: this.estatus, fechaInicioZoned: this.filtro.fechaInicio, fechaFin: this.filtro.fechaFin});
      this.listClinicas = listaClinicas.map(e => {
        if (this.idsClinicas.length > 0 && this.idsClinicas.includes(e.idClinica)) {
          return { ...e, selected: true };
        }
        return { ...e, selected: false };
      });
    },
    cambiarEstatusAceptado(row) {

      this.$swal.fire({
        title: "¿Desea Aceptar el cashback?",
        icon: "danger ",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: (confirm) => {
          if (confirm)
            this.movimientoService.cambiarEstatusAceptado(row.item.idMovimiento).then(()=>{
              this.listarCashBack();
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      });

    },
    cambiarEstatusRechazado(row) {
      this.$swal.fire({
        title: "¿Desea Rechazar el cashback?",
        icon: "danger ",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: (confirm) => {
          if (confirm)
            this.movimientoService.cambiarEstatusRechazado(row.item.idMovimiento).then(()=>{
              this.listarCashBack();
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      });
    },
    itemEnEstatusFinal(item) {
      return item.idEstatusMovimiento === 4 || item.idEstatusMovimiento === 5;
    },
    obtenerDiasParaResolver({item}) {
      const dias = item.diasSolucion;
      const d1 = new Date(item.fechaAlta)
      const d2 = new Date(d1)
      d2.setDate(d2.getDate() + dias)
      const d3 = new Date();
      return this.movimientoService.formatters.date.diasDiferencia(d3, d2);
    },
    usuarioAutorizaMovimiento(autorizaciones) {
      return !!autorizaciones.find(autorizacion => autorizacion.idEmpleado === this.$localStorageService.getIdEmpleado())
    },
    autorizacionesCompletas(autorizaciones) {
      return !autorizaciones.find(autorizacion => autorizacion.autorizado === false)
    }
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();

    Date.prototype.addDays = function(dias) {
      var fecha = new Date(this.valueOf());
      fecha.setDate(fecha.getDate() + dias);
      return fecha;
    }

    /*this.movimientoService.listarCashBack({estatusMovimiento: this.estatus});
    this.$root.$on('reload-cashback', async (estatus) => {
      if (estatus === this.estatus) {
        this.movimientoService.listarCashBack({estatusMovimiento: this.estatus});
      }
    })*/
  },
  computed: {
    isLoading() {
      return this.movimientoService.loading;
    }
  }
}
</script>
